import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"main-banner-page\" class=\"position-relative page-header section-nav-smooth parallax blog-detail-header\" style=\"background-image:url(&#39;fe/asset/img/big-bg-white.png&#39;);\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"page-titles whitecolor text-center padding_top\"></div></div></div><div class=\"title-wrap bg-custom\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 whitecolor\"><h3 class=\"float-left\">Kontak</h3><ul class=\"breadcrumb top10 bottom10 float-right\"><li class=\"breadcrumb-item\"><a href=\"/\">Beranda</a></li><li class=\"breadcrumb-item\">Kontak</li></ul></div></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "stayconnect1",
  class: "bglight position-relative padding_top padding_bottom_half noshadow",
  style: {"background-image":"url('fe/asset/img/big-bg-white.png')","background-size":"cover","border-radius":"10px !important"}
}
const _hoisted_3 = { class: "container whitebox" }
const _hoisted_4 = { class: "widget py-5" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 col-sm-6 order-sm-2" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h2 class=\"heading bottom30 darkcolor font-light2 pt-1\"><span class=\"font-normal\">FAQ</span><span class=\"divider-left\"></span></h2><div class=\"col-md-12\"><p class=\"heading_space\"></p></div>", 2)
const _hoisted_9 = { id: "accordion" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["id"]
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "col-md-6 col-sm-6" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<h2 class=\"heading bottom30 darkcolor font-light2 pt-1\"><span class=\"font-normal\">Contact</span> Us <span class=\"divider-left\"></span></h2><div class=\"col-md-12\"><p class=\"heading_space\"></p></div>", 2)
const _hoisted_17 = {
  class: "heading-title wow fadeInUp",
  "data-wow-delay": "300ms"
}
const _hoisted_18 = { class: "row px-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 col-sm-12",
  id: "result"
}, null, -1)
const _hoisted_20 = { class: "col-md-12 col-sm-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "name1",
  class: "d-none"
}, null, -1)
const _hoisted_23 = { class: "col-md-12 col-sm-12" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "email1",
  class: "d-none"
}, null, -1)
const _hoisted_26 = { class: "col-md-12 col-sm-12" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "message1",
  class: "d-none"
}, null, -1)
const _hoisted_29 = { class: "col-md-12 col-sm-12" }
const _hoisted_30 = { class: "form-group bottom25 text-center" }
const _hoisted_31 = { class: "d-flex w-100 justify-content-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    id: "submit_btn1",
    class: "contact_btn button gradient-btn w-100"
  }, " Kirim ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_RecaptchaV2 = _resolveComponent("RecaptchaV2")!
  const _component_Form = _resolveComponent("Form")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rulesList, (item, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "card"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("a", {
                        class: "card-link darkcolor",
                        "data-toggle": "collapse",
                        href: `#collapse${key}`
                      }, _toDisplayString(item.answer), 9, _hoisted_11)
                    ]),
                    _createElementVNode("div", {
                      id: `collapse${key}`,
                      class: "collapse",
                      "data-parent": "#accordion"
                    }, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.answer), 1)
                    ], 8, _hoisted_12)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_b_overlay, {
                  show: _ctx.isLoading,
                  rounded: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Form, {
                      class: "getin_form border-form",
                      id: "login",
                      "validation-schema": _ctx.schema,
                      onSubmit: _ctx.submitFaq
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createVNode(_component_Field, {
                                class: "form-control",
                                id: "name",
                                type: "text",
                                placeholder: "Name:",
                                required: "",
                                name: "name",
                                modelValue: _ctx.loginData.name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.name) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                class: "text-danger",
                                name: "name"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _hoisted_25,
                              _createVNode(_component_Field, {
                                class: "form-control",
                                type: "email",
                                id: "email",
                                placeholder: "Email:",
                                name: "email",
                                modelValue: _ctx.loginData.email,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginData.email) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                class: "text-danger",
                                name: "email"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode(_component_Field, {
                                as: "textarea",
                                class: "form-control",
                                id: "message",
                                placeholder: "Message:",
                                requiredtextarea: "",
                                name: "message",
                                modelValue: _ctx.loginData.message,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginData.message) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                class: "text-danger",
                                name: "message"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createVNode(_component_RecaptchaV2, {
                                  onWidgetId: _ctx.handleWidgetId,
                                  onErrorCallback: _ctx.handleErrorCalback,
                                  onExpiredCallback: _ctx.handleExpiredCallback,
                                  onLoadCallback: _ctx.handleLoadCallback,
                                  language: "id"
                                }, null, 8, ["onWidgetId", "onErrorCallback", "onExpiredCallback", "onLoadCallback"])
                              ])
                            ])
                          ]),
                          _hoisted_32
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-schema", "onSubmit"])
                  ]),
                  _: 1
                }, 8, ["show"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}